module.exports = __webpack_public_path__ + "img/P2-C2.58bb0907.svg";